export default __webpack_public_path__ + "static/4-f953be6c5c3c0b4658eec48d2c325fc3.png";